<template>
  <div style="background: #fff">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('page.termsUse') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="title">
        <h2>
          {{ pageList01[0] ? pageList01[0].page_name : '' }}
        </h2>
      </div>
      <div
        class="content"
        v-html="pageList01[0] ? pageList01[0].page_content : ''"
      ></div>
    </div>
  </div>
</template>
<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import _ from 'underscore';
import routerTo from '@/router/routerTo';
export default {
  data() {
    return {
      pageList: [],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    pageList01() {
      return this.localePageList01(this.locale);
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.getPageList();
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async getPageList() {
      const getPageList = await www.getPageList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        page_size: '100',
      });
      this.pageList = getPageList.data;
    },
    localePageList01(locale) {
      return _.filter(this.pageList, (cur) => {
        return (
          cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale) &&
          cur.page_name === this.$t('page.termsUse.title')
        );
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrapper {
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  .title {
    padding: 20px 0;
    text-align: center;
    h2 {
      margin: 20px 0;
      color: #191b26;
      font-weight: normal;
      font-size: 30px;
      line-height: 42px;
    }
  }
  .content {
    margin-bottom: 20px;
    padding: 60px 80px;
    border-radius: 10px;
    font-size: 16px;
    line-height: 32px;
    background: #f6fcf9;
  }
  .content /deep/ p {
    margin-bottom: 24px;
    text-align: justify;
  }
  .content /deep/ img {
    max-width: 100%;
  }
}
</style>
